import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import { libraryShape, listShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import ListCard from 'app/components/shared/ListCard';

import UserCard from 'app/components/shared/UserCard';
import { hasCreatorAvatar, hasLibraryName } from 'app/helpers/list/listCardHelpers';

const ListCardAdapter = ({
  creator,
  handleListImageClick,
  handleListTitleClick,
  horizontal,
  imageIsDecorative,
  largeImage,
  library,
  list,
  showDate,
  showDescription,
  showUserBadge,
  smallHeading,
  titleTag,
  trackCreatorClick
}) => {
  const intl = useIntl();

  const renderUserCard = () => {
    const hasAvatar = hasCreatorAvatar(creator, library);
    const hasLibraryFullName = hasLibraryName(creator);

    const overrideScreenReaderMessageUserName = intl.formatMessage(
      { id: 'sr_list_card_creator' },
      { name: creator.get('name') }
    );

    return (
      <UserCard
        hasAvatar={hasAvatar}
        hasBadge={showUserBadge}
        hasLibraryFullName={hasLibraryFullName}
        hasSmallUserName
        ugcType="list"
        overrideScreenReaderMessageUserName={overrideScreenReaderMessageUserName}
        trackProfileLinkClick={trackCreatorClick}
        user={creator}
      />
    );
  };

  return (
    <ListCard
      creator={creator}
      handleListImageClick={handleListImageClick}
      handleListTitleClick={handleListTitleClick}
      horizontal={horizontal}
      imageIsDecorative={imageIsDecorative}
      largeImage={largeImage}
      list={list}
      renderUserCard={renderUserCard}
      showDate={showDate}
      showDescription={showDescription}
      smallHeading={smallHeading}
      titleTag={titleTag}
    />
  );
};

ListCardAdapter.defaultProps = {
  handleListImageClick: () => null,
  handleListTitleClick: () => null,
  horizontal: false,
  imageIsDecorative: false,
  largeImage: false,
  showDate: false,
  showDescription: false,
  showUserBadge: false,
  smallHeading: false,
  titleTag: 'h3',
  trackCreatorClick: () => null
};

ListCardAdapter.propTypes = {
  creator: userIdentityShape.isRequired,
  handleListImageClick: PropTypes.func,
  handleListTitleClick: PropTypes.func,
  horizontal: PropTypes.bool,
  imageIsDecorative: PropTypes.bool,
  largeImage: PropTypes.bool,
  library: libraryShape.isRequired,
  list: listShape.isRequired,
  showDate: PropTypes.bool,
  showDescription: PropTypes.bool,
  showUserBadge: PropTypes.bool,
  smallHeading: PropTypes.bool,
  titleTag: PropTypes.string,
  trackCreatorClick: PropTypes.func
};

export default ListCardAdapter;
